export const ADD_INGREDIENTS = "ADD_INGREDIENTS";
export const REMOVE_INGREDIENTS = "REMOVE_INGREDIENTS";
export const INIT_INGREDIENTS = "INIT_INGREDIENTS";
export const SET_INGREDIENTS = "SET_INGREDIENTS";
export const FETCH_INGREDIENTS_FAILED = "FETCH_INGREDIENTS_FAILED";
export const BURGER_BUILDING_STARTED = "BURGER_BUILDING_STARTED";
export const RESET_BURGER_BUILDER = "RESET_BURGER_BUILDER";

// export const BURGER_PURCHASED = "BURGER_PURCHASED";
// export const BURGER_PURCHASE_FAILED = "BURGER_PURCHASE_FAILED";
// export const BURGER_PURCHASE_STARTED = "BURGER_PURCHASE_STARTED";
// export const BURGER_PURCHASE_COMPLETED = "BURGER_PURCHASE_COMPLETED";

export const AUTHCHECK_START = "AUTHCHECK_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const REMOVE_ERRORS = "REMOVE_ERRORS";
export const SIGNOUT = "SIGNOUT";
